import { DEFAULT_ADSENSE_CONFIG } from './adsense-config';
import { DEFAULT_GOOGLE_CLIENT_ID, mergeRuntimeConfig, type AppConfig } from './app-config';
import { getServerEnv } from './env';

const DEFAULT_LOCAL_API = 'http://localhost:3000';
const DEFAULT_LOCAL_WEB = 'http://localhost:3001';

export function resolveServerRuntimeConfig(): AppConfig {
  const env = getServerEnv();

  return mergeRuntimeConfig({
    production: env.NODE_ENV === 'production',
    enableMarketingTags: env.KW_ENABLE_MARKETING_TAGS ?? false,
    apiBaseUrl: env.API_BASE_URL || env.NEXT_PUBLIC_API_BASE_URL || DEFAULT_LOCAL_API,
    webDomain: env.KW_WEB_DOMAIN || DEFAULT_LOCAL_WEB,
    googleClientId: env.KW_GOOGLE_CLIENT_ID || DEFAULT_GOOGLE_CLIENT_ID,
    jobsPageUrl: env.KW_JOBS_PAGE_URL,
    careerCoachingPageUrl: env.KW_CAREER_COACHING_PAGE_URL,
    proExamplesUrl: env.KW_PRO_EXAMPLES_URL,
    gcsStorageUrl: env.KW_GCS_STORAGE_URL,
    allowAiModelSelection: env.KW_ALLOW_AI_MODEL_SELECTION ?? false,
    posthogKey: env.KW_POSTHOG_KEY || '',
    pusherKey: env.KW_PUSHER_KEY || '',
    razorPayKey: env.KW_RAZORPAY_KEY || '',
    paddleToken: env.KW_PADDLE_TOKEN || '',
    dodoCheckoutMode: env.KW_DODO_CHECKOUT_MODE === 'live' ? 'live' : 'test',
    whatsappVerificationGeoGate: env.KW_WHATSAPP_VERIFICATION_GEO_GATE ?? false,
    upgradeExperimentsEnabled: env.KW_UPGRADE_EXPERIMENTS_ENABLED ?? false,
    upgradeExperimentFlags: (env.KW_UPGRADE_EXPERIMENT_FLAGS || '').trim(),
    adsense: {
      ...DEFAULT_ADSENSE_CONFIG,
      enabled: env.KW_ADSENSE_ENABLED ?? false,
      clientId: env.KW_ADSENSE_CLIENT_ID || DEFAULT_ADSENSE_CONFIG.clientId,
    },
  });
}

export function getClientRuntimeConfig(): AppConfig | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.__KW_RUNTIME_CONFIG__ ?? null;
}

export function resolveApiBaseUrl(): string {
  const clientConfig = getClientRuntimeConfig();
  if (clientConfig?.apiBaseUrl) {
    return clientConfig.apiBaseUrl;
  }
  return resolveServerRuntimeConfig().apiBaseUrl;
}
